import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Dropdown from 'react-dropdown';

export const ModalModificaCategoria = (props) => {
	const {
		UseModalModifyCategoria,
		setUseModalModifyCategoria,
		SetNombreModifyCategoria,
		nombreModifyCategoria,
		modifyCategoria,
		ListaSuperCategorias,
		ListaNombreSuperCategorias,
	} = props;

	const seleccionarSuperCategoria = (nombreSuperCategoria) => {
		ListaSuperCategorias.map((superCategoria) => {
			if (superCategoria.nombre === nombreSuperCategoria) {
				SetNombreModifyCategoria({
					...nombreModifyCategoria,
					superCategoria: superCategoria.id,
				});
			}
		});
	};

	return (
		<>
			<Modal
				centered={true}
				isOpen={UseModalModifyCategoria}
				toggle={() => setUseModalModifyCategoria(false)}
			>
				<ModalHeader>
					<b>Modificar nombre de la categoria</b>
				</ModalHeader>
				<ModalBody>
					<div>Seleccione el nuevo nombre</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>
							Seleccione la Super Categoria a la que desea añadir el servicio
						</div>
						<div style={{width: '231px'}}>
							<Dropdown
								className='miDropDown'
								options={ListaNombreSuperCategorias}
								onChange={(e) => seleccionarSuperCategoria(e.value)}
								placeholder='Valor por defecto'
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Seleccione el nombre de la categoria</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								placeholder={'Nombre de la Categoria'}
								value={nombreModifyCategoria.nombre}
								onChange={(e) =>
									SetNombreModifyCategoria({
										...nombreModifyCategoria,
										nombre: e.target.value,
									})
								}
							/>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal-categoria'>
						<div
							className='button'
							onClick={() => setUseModalModifyCategoria(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => modifyCategoria()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
